module.exports = __webpack_public_path__ + "img/Customs-clearance4.b7396157.png";